import { memo } from 'react';
import { SimpleSkeleton } from '@/sub-luca-plugin/compatible-components';
import './index.scss';

const QaSkeleton = () => {
    return (
        <div className="qa-skeleton">
            <SimpleSkeleton className="qa-skeleton__nav" />
            <div className="qa-skeleton__dialogue-area">
                <div className="qa-skeleton__dialogue-area-user">
                    <SimpleSkeleton className="dialogue-area-skeleton__content" style={{ width: '80px' }} />
                </div>
                <div className="qa-skeleton__dialogue-area-gpt">
                    <SimpleSkeleton className="dialogue-area-skeleton__content" style={{ width: '120px' }} />
                </div>
                <div className="qa-skeleton__dialogue-area-gpt">
                    <SimpleSkeleton className="dialogue-area-skeleton__content" style={{ width: '300px' }} />
                </div>
                <div className="qa-skeleton__dialogue-area-user">
                    <SimpleSkeleton className="dialogue-area-skeleton__content" style={{ width: '100px' }} />
                </div>
                <div className="qa-skeleton__dialogue-area-gpt">
                    <SimpleSkeleton className="dialogue-area-skeleton__content" style={{ width: '80px' }} />
                </div>
                <div className="qa-skeleton__dialogue-area-user">
                    <SimpleSkeleton className="dialogue-area-skeleton__content" style={{ width: '160px' }} />
                </div>
                <div className="qa-skeleton__dialogue-area-gpt">
                    <SimpleSkeleton className="dialogue-area-skeleton__content" style={{ width: '320px' }} />
                </div>
                <div className="qa-skeleton__dialogue-area-user">
                    <SimpleSkeleton className="dialogue-area-skeleton__content" style={{ width: '100px' }} />
                </div>
            </div>
            <SimpleSkeleton className="dialogue-area-skeleton__tool" />
        </div>
    );
};

export default memo(QaSkeleton);
